import generateUtilityClass from "@suid/base/generateUtilityClass";
import generateUtilityClasses from "@suid/base/generateUtilityClasses";
export function getAvatarUtilityClass(slot) {
    return generateUtilityClass("MuiAvatar", slot);
}
const avatarClasses = generateUtilityClasses("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback",
]);
export default avatarClasses;
